// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/my-routes/index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/my-routes/index.tsx"); } },
  "./(auth)/plans/[planId]/[routeId].tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/plans/[planId]/[routeId].tsx"); } },
  "./(auth)/plans/[planId]/index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/plans/[planId]/index.tsx"); } },
  "./(auth)/plans/index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/plans/index.tsx"); } },
  "./(auth)/plans/new.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/plans/new.tsx"); } },
  "./(auth)/rules/[ruleSetId].tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/rules/[ruleSetId].tsx"); } },
  "./(auth)/rules/index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/rules/index.tsx"); } },
  "./(auth)/search.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/search.tsx"); } },
  "./(auth)/settings/billing.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/settings/billing.tsx"); } },
  "./(auth)/settings/index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/(auth)/settings/index.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/_layout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/index.tsx"); } },
  "./login.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/apps/expo-app/app/login.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;